import { render, staticRenderFns } from "./Extensions.vue?vue&type=template&id=6f279c10"
import script from "./Extensions.vue?vue&type=script&lang=ts"
export * from "./Extensions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports